import React,{useState} from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
// import Navbar2 from '../components/Navbar2';
import Footer from '../components/Footer';
import Amenitiespage from '../components/Amenities';
import Sroll from '../components/Scroll';
import ThanksPage from '../components/ThanksComp';

function Thanks() {
   
    const [isOpen,setIsOpen]= useState(false);
    const toggle= ()=>{
        setIsOpen(!isOpen);
    }


    return (
        <div>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            {/* <Navbar2 toggle={toggle}  />  */}
            <Navbar toggle={toggle}  /> 
            <ThanksPage />
            <Sroll />
            <Footer />
        </div>
    )
}

export default Thanks
